<template>
  <div class="column-100">

    <p class="text-align-center input-error-message" v-if="error_message">
      {{error_message}}
    </p>

    <div class="checks_outer margin-horizontal-default" :class="{'validate-error':error_message}">
      <div class="checks">
        <input type="checkbox" name="email_optin" id="email_optin" value="1" v-model="email_optin">
        <label for="email_optin"><span>Opt in to our EMAIL notifications.<sup>{{(is_required ? '*' : '')}}</sup></span></label>
      </div>
    </div>

  </div>
</template>

<script>
    import {fields} from '../../mixins/requests/fields'
    import {field_component_mixin} from './field_component_mixin'

    export default {
        name: "email_optin",
        mixins: [fields, field_component_mixin],
        data(){
            return{
                field_name: "email_optin"
            }
        },
        computed: {

        },
    }
</script>

<style scoped>

</style>